import { EFeatureNames, EPermissions } from '@albacross/types'

import { useCustomerFeatures } from './useCustomerFeatures'
import { useCustomerUsers } from './useCustomerUsers'

export const useOutreachSeats = () => {
  const { data: customerFeatures } = useCustomerFeatures()
  const { data: users, isPending, isError } = useCustomerUsers() as any
  const used = users?.filter((user: any) => !!user.role?.permissions?.[EPermissions.OutreachSender])?.length || 0
  const total = customerFeatures[EFeatureNames.OutreachSenders]
  return {
    used,
    total,
    isPending,
    isError,
    blockNew: isPending || isError || used >= total,
  }
}
